import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  Appliance,
  RemoteData,
  remoteDataError,
  remoteDataLoading,
  remoteDataNotFetched,
  remoteDataOK,
} from '@common/util-models';
import * as ApplianceDetailsActions from './appliances.actions';

export const APPLIANCES_KEY = 'appliances';

export interface AppliancesState extends EntityState<Appliance> {
  remoteState: RemoteData<null>;
  selectedSkyBox?: Appliance;
}

export interface AppliancesPartialState {
  readonly [APPLIANCES_KEY]: AppliancesState;
}

export const appliancesAdapter: EntityAdapter<Appliance> =
  createEntityAdapter<Appliance>({
    selectId: (appliance) => appliance.code,
  });

export const initialAppliancesState: AppliancesState =
  appliancesAdapter.getInitialState({
    remoteState: remoteDataNotFetched(),
  });

export const appliancesReducer = createReducer(
  initialAppliancesState,
  on(ApplianceDetailsActions.loadAppliances, (state) => ({
    ...state,
    remoteState: remoteDataLoading(),
  })),

  on(ApplianceDetailsActions.loadAppliancesSuccess, (state, { appliances }) =>
    appliancesAdapter.setAll(appliances, {
      ...state,
      remoteState: remoteDataOK(null),
    })
  ),

  on(ApplianceDetailsActions.loadAppliancesFailure, (state, { error }) => ({
    ...state,
    remoteState: remoteDataError(error),
  })),

  on(ApplianceDetailsActions.selectSkyBox, (state, { appliance }) => ({
    ...state,
    selectedSkyBox: appliance,
  }))
);
